"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = CardTitle;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const ThemeContext_1 = require("../ThemeContext");
function CardTitle(props) {
    const THEME = (0, ThemeContext_1.useTheme)();
    return ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: [
            {
                flexDirection: 'row',
                alignItems: 'center'
            },
            props.style
        ], children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flex: 1, gap: 2 }, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { "aria-label": props["aria-label"] ?? props.title, style: {
                            fontSize: 18,
                            fontWeight: '500',
                            color: THEME.Text
                        }, children: props.title }), !!props.subtitle &&
                        (0, jsx_runtime_1.jsx)(react_native_1.Text, { "aria-label": props.subtitle, style: {
                                fontSize: 14,
                                color: THEME.TextDisabled
                            }, children: props.subtitle })] }), (0, jsx_runtime_1.jsx)(react_native_1.View, { children: props.children })] }));
}
